
const apisObject = {

    collection: {

        default: [
            { title: '{{lang}}Get single record', value: 'getSingleRecord' },
        ],

        
    },

}




export { apisObject }